var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_2178_476)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.913 13.5615H13.1872V15.8343H10.913V13.5615ZM8.63867 13.5615H10.913V15.8343H8.63867V13.5615ZM8.63867 15.8343H10.913V18.107H8.63867V15.8343Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4549 13.5615H17.7291V15.8343H15.4549V13.5615ZM17.7291 13.5615H20.0034V15.8343H17.7291V13.5615ZM20.0034 13.5615H22.2777V15.8343H20.0034V13.5615ZM17.7291 15.8343H20.0034V18.107H17.7291V15.8343Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5431 13.5615H26.8174V15.8343H24.5431V13.5615ZM24.5431 15.8343H26.8174V18.107H24.5431V15.8343ZM29.0917 13.5615H31.3659V15.8343H29.0917V13.5615ZM29.0917 15.8343H31.3659V18.107H29.0917V15.8343Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63867 19.6226H10.913V21.8953H8.63867V19.6226ZM8.63867 21.8953H10.913V24.168H8.63867V21.8953ZM8.63867 24.168H10.913V26.4407H8.63867V24.168ZM10.913 24.168H13.1872V26.4407H10.913V24.168Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7291 19.6226H20.0034V21.8953H17.7291V19.6226ZM17.7291 21.8953H20.0034V24.168H17.7291V21.8953ZM17.7291 24.168H20.0034V26.4407H17.7291V24.168Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8174 19.6226H29.0917V21.8953H26.8174V19.6226ZM24.5431 21.8953H26.8174V24.168H24.5431V21.8953ZM24.5431 24.168H26.8174V26.4407H24.5431V24.168ZM29.0917 21.8953H31.3659V24.168H29.0917V21.8953ZM29.0917 24.168H31.3659V26.4407H29.0917V24.168Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2178_476",
    x1: 40,
    y1: -0.00000227356,
    x2: 1.85606,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AF79E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9945FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.90ecfe595664fe38d46247e478ac6f64.svg";
export { ForwardRef as ReactComponent };